import productModel from './productModel';


const lineItemsModel = function googleAnalyticsLineItemsModel(items, options = {}, isPurchaseEvent) {
  const products = [];
  let index = 0;

  items.forEach(item => {
    products.push(productModel(
      item,
      { quantity: item.quantity, affiliation: options.affiliation, index: index++ },
      isPurchaseEvent,
    ));

    item.options.forEach(option => {
      products.push(productModel(
        {
          id: option.selectedValueId,
          brand: item.brand,
          productName: option.displayName,
          primaryCategoryName: item.primaryCategoryName,
          price: {
            sales: {
              value: 0,
            },
          },
        },
        { quantity: item.quantity, affiliation: options.affiliation, index: index++ },
        isPurchaseEvent,
      ));
    });
  });

  return products;
};

export default lineItemsModel;
